import { render, staticRenderFns } from "./UserPattern.vue?vue&type=template&id=516d4f6c&scoped=true&"
import script from "./UserPattern.vue?vue&type=script&lang=js&"
export * from "./UserPattern.vue?vue&type=script&lang=js&"
import style0 from "./UserPattern.vue?vue&type=style&index=0&id=516d4f6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d4f6c",
  null
  
)

export default component.exports